import { Grid, GridCellProps, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid'
import { canAccessSegment } from 'app/utils'
import { HeaderComponent } from 'components/header/component'
import { RSSFeedIcon } from 'components/icons/rssfeed'
import { TwitterIcon } from 'components/icons/twittersmall'
import { Loading } from 'components/loading'
import { TabMenu } from 'components/tab-menu/component'
import { RasaContext } from 'context'
import { Dataset } from 'generic/dataset'
import * as GenericRedux from 'generic/genericRedux'
import { RasaReactComponent } from 'generic/rasaReactComponent'
import isNil from 'lodash/isNil'
import * as React from 'react'
import { Input, Row } from 'reactstrap'
import { BillingPlanDetailCode } from 'shared_server_client/types/billing_plan'
import { DEFAULT_COMMUNITY_PARTNER_CODES } from '../../../shared_server_client/constants'
import {ActiveCell} from '../kendocells'
import './edit-source.scss'
import { EditSourceModal } from './edit-source-modal'

export interface Source {
  source_type: string,
  name: string,
  source_url: string,
  id: string|number,
  whitelist_matches: number,
  blacklist_matches: number,
  community_partner_code: string,
}

export interface Filter {
  applies_to: string,
  filter_group_id: number,
  id: number,
  is_active: boolean,
  name: string,
  type: string,
}

interface EditSourceState {
  communityId?: string,
  filters: Filter[],
  hasIncludeExcludeConfigAccess: boolean,
  hasSegmentAccess: boolean
  id: string,
  includeExcludeLimit: number,
  key: string,
  isModalOpen: boolean,
}

type EditSourceProps = GenericRedux.AllComponentPropsWithModal<Source>

const FiltersMenus = [
  {
    name: 'Include',
    key: 'whitelist',
    component: null,
  },
  {
    name: 'Exclude',
    key: 'blacklist',
    component: null,
  },
]

class EditSourceComponent extends RasaReactComponent<EditSourceProps, EditSourceState> {
  public static contextType = RasaContext;
  constructor(p: any) {
    super(p, 'communitySource')
    this.state = {
      filters: [],
      hasIncludeExcludeConfigAccess: false,
      hasSegmentAccess: false,
      key: 'whitelist',
      isDirty: false,
      isLoading: false,
      isSaving: false,
      id: null,
      includeExcludeLimit: 0,
      isModalOpen: false,
    }
  }

  public componentDidMount() {
    this.context.user.init().then(({activeCommunity}) => {
      const includeExcludeFeature = activeCommunity.billingInfo.currentPlan.details.filter((x) =>
        x.billing_plan_code === BillingPlanDetailCode.ADVANCED_SOURCE_CONFIG)[0]
      const hasIncludeExcludeConfigAccess = includeExcludeFeature && includeExcludeFeature.limit_val !== 0
      const avlFeatures: BillingPlanDetailCode[] = activeCommunity.billingInfo.currentPlan.features || []
      this.setState({
      communityId: activeCommunity.communityId,
      hasIncludeExcludeConfigAccess,
      includeExcludeLimit: includeExcludeFeature ? includeExcludeFeature.limit_val : 0})
      canAccessSegment(avlFeatures, activeCommunity.communityId).then((canAccess) => {
        this.setState({hasSegmentAccess: canAccess})
      })
    })
    const id: string = this.context.store.getState().app.params.id
    this.loadOnRouting(id, '/content/editsource').then(() => {
      new Dataset().loadCommunityDataset(
          'communitySubscriptionFilters',
          this.state.communityId,
          [{param: 'sourceId', value: id}])
        .then((response) => {
          this.setState({filters: response[0], id})
      })
    })
  }

  public render = () => {
    return(
    <div className="edit-source">
      <Row>
        <HeaderComponent
          title={'SOURCES'}
          subTitle={'Edit Source'}
        />
      </Row>
    {this.state.isLoading
    ?
      <div>
        <Loading size="64"/>
      </div>
    : ( !this.state.isLoading && !this.props.data.id )
    ?
      <div>
        <h3>Something has gone wrong</h3>
      </div>
    :
      <div>
        <Row>
          <div className="source-box">
            <div className="text">
              {this.props.data.source_type === 'Twitter' ?
              <TwitterIcon svgwidth={16} svgheight={16}/> :
              <RSSFeedIcon svgwidth={16} svgheight={16}/> }
              &nbsp;
              <strong>{this.props.data.source_type}</strong>
              <span className="rename" onClick={this.openEditModal}>Edit</span>
            </div>
            <div>
              <div className="text grey">
                {this.props.data.name}
              </div>
              {this.state.hasSegmentAccess ?
                <div className="text grey">
                  Segment: {this.props.data.community_partner_code || DEFAULT_COMMUNITY_PARTNER_CODES.ALL}
                </div> : null
              }
            </div>
          </div>
        </Row>
        <Row>
          <div className="filters-section">
            <h5>Filters for This Source</h5>
            <div className={this.state.hasIncludeExcludeConfigAccess ? 'left-bar' : ''}>
              <p>Activate or deactivate your filters for this source.</p>
              <p>
                Include filter - an article will <strong>only</strong> come in if it matches one of these topics.<br/>
                Exclude filter - <strong>no</strong> articles will come in that match one or more of these topic.<br/>
              </p>
            </div>
            {this.state.hasIncludeExcludeConfigAccess &&
              <div className="numeric-toggles">
                <div className="section">
                  <span className="toggle-title"># of includes</span>
                  <Input className="numberic-toggles-input" value={this.props.data.whitelist_matches}
                          min={1}
                          max={this.state.includeExcludeLimit > -1 ? this.state.includeExcludeLimit : 500 }
                          type="number"
                          name="includes"
                          onChange={(e) => this.onDataChange('whitelist_matches', e.target.value)}/>
                </div>
                <div className="section">
                  <span className="toggle-title"># of excludes</span>
                  <Input className="numberic-toggles-input" value={this.props.data.blacklist_matches}
                          min={1}
                          max={this.state.includeExcludeLimit > -1 ? this.state.includeExcludeLimit : 500 }
                          type="number"
                          name="includes"
                          onChange={(e) => this.onDataChange('blacklist_matches', e.target.value)}/>
                </div>
              </div>}
            <div className="clear">
              <TabMenu menus={FiltersMenus}
                    selectedItemKey="whitelist"
                    onSelect={({key}) => this.setState({key})} />
            </div>
            <div className="filters-grid rasa-data-grid">
              <Grid data={this.state.filters.filter((e: Filter) => e.type === this.state.key)}
              editField="is_active"
                    >
                <Column  field="is_active" title="Status" cell={this.FilterActiveCell} width="85" />
                <Column field="name" title="Topic, Keyword, or Phrase" editable={false} />
                <GridNoRecords><a href="/content/filters">Add a filter</a></GridNoRecords>
              </Grid>
            </div>
          </div>
        </Row>
      </div>
    }
    <EditSourceModal
      isOpen={this.state.isModalOpen}
      sourceData={this.props.data}
      onClose={() => this.setState({isModalOpen: false})}
      onSave={() => {
        this.setState({isModalOpen: false})
        window.location.reload()
      }}
    />
    </div>)
  }

  private openEditModal = () => {
    this.setState({isModalOpen: true})
  }

  private FilterActiveCell = (props: GridCellProps) => {
    return <ActiveCell {...props} onChange={this.toggleFilter} />
  }

  private onDataChange = (propertyName, data) => {
    this.propertyChanged(propertyName, data)
    this.saveRecord(this.props.data.id)
  }

  private toggleFilter = (e: any) => {
    return this.context.entityMetadata.getEntityObject('community_filtered_subscription')
              .then((entity) => {
                entity.setRecordId(this.state.communityId, e.dataItem.id)
                entity.data.isActive = !e.dataItem.is_active
                if (isNil(e.dataItem.id)) {
                  entity.data.subscriptionId = this.state.id
                  entity.data.filterGroupId = e.dataItem.filter_group_id
                  entity.data.filterType = e.dataItem.type
                }
                return entity.save().then(() => {
                  const filters = this.state.filters
                  filters[this.state.filters
                          .findIndex((record) => record === e.dataItem)].is_active = !e.dataItem.is_active
                  this.setState({filters})
                })
              })
  }

}

export const ContentPoolEditSource = GenericRedux.registerNewNestedComponent(
  EditSourceComponent, 'edit_source')
